// extracted by mini-css-extract-plugin
export default {"status":"PermitsTable_status__evnrw","columnTitle":"PermitsTable_columnTitle__QzFKH"};